"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("../../http");
var Message_1 = require("../Message");
var constants_1 = require("../constants");
/**
 *  An Impression event is sent when an advertisement is added to the DOM, or we otherwise
 * think that an impression has occured
 * in:
 *   adUnitId: the id on the div that this ad is going to render in
 *   zoneId: the adzerk zone, if applicable
 *   flightId: this is an indentifier for who won the ad
 *   price: the revenue in USD associated with this ad. May not be accurate for ads that
 *          are not from header bidding
 * out:
 *   this function returns a UUID for the event that was sent
 * side effects:none
 */
var sendImpression = function (adUnitId, zoneId, flightId, price, dimensions) {
    // load common data from the adUnitId cache
    var page = window.ads[adUnitId]["page"];
    var storyId = window.ads[adUnitId]["story_id"];
    var partId = window.ads[adUnitId]["part_id"];
    var adPartner = window.ads[adUnitId]["ad_partner"];
    var requestId = window.ads[adUnitId][adPartner + "_request"];
    var message = (0, Message_1.getCommonMessageFields)(page, storyId, partId);
    var requestOffset = Date.now() - window.ads[adUnitId][constants_1.startTimeField];
    // impression specific fields
    message.ad_partner = adPartner;
    message.page_view_id = window.ads.page_view_id;
    message.adunit_id = adUnitId;
    message.price = price;
    message.adunit_format = dimensions;
    message.request_id = requestId;
    message.placement = adUnitId.split("-")[0];
    message.zone_id = zoneId;
    message.flight_id = flightId;
    message.request_offset = requestOffset;
    (0, http_1.sendAthaEvent)("impression", message);
    return message["id"];
};
exports.default = sendImpression;
